import { filterHtml, highlightedSearchText } from "./ConversationView";


const TextMessageBox = ({ searchMessageId, message, searchQuery, textFrom }) => {
  return (
    searchMessageId ? (
      <div
        className="message-dangerous"
        dangerouslySetInnerHTML={{ __html: searchMessageId === message._id ? highlightedSearchText(message.content, searchQuery) : message.content }}
      ></div>
    ) : (
      <p
        className="message" dangerouslySetInnerHTML={{ __html: filterHtml(message.content, searchQuery, textFrom)}}
      ></p>
    )
  )
};

export default TextMessageBox;
